import { StanFilterConfig } from '@/components/core-components/StanFilters/types';

/**
 * Filter configurations for email recipients page
 * Only includes name and email filters (simplified from main recipients tab)
 */
export const EMAIL_RECIPIENT_FILTER_CONFIGS: StanFilterConfig[] = [
    {
        id: 'recipients-name',
        label: 'Name',
        type: 'text',
    },
    {
        id: 'recipients-eid',
        label: 'Email',
        type: 'text',
    },
];
